import { Component, computed, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { SelectModule } from 'primeng/select';

import { InjectAttributeDirective } from '@directives/inject-attribute.directive';

import { RouterState } from '@cxc/core/services';
import { CutOffDateState } from '@services/state/cut-off-date-state/cut-off-date.state';

@Component({
  selector: 'cut-off-date',
  standalone: true,
  imports: [SelectModule, FormsModule, InjectAttributeDirective],
  template: `
    <div class="flex flex-col gap-2">
      <p class="text-muted">Cut-off date</p>
      <div class="flex gap-2">
        <p-select
          [options]="cutOffDateState.cutOffs()"
          optionLabel="date"
          optionValue="date"
          [placeholder]="cutOffDateState.currentPeriod()"
          [(ngModel)]="cutOffDateState.currentPeriod"
          [injectAttribute]="[
            {
              CSSPath: '.p-select-label, .p-select-dropdown',
              attribute: 'analytics-label',
              value: analyticsLabel(),
            },
          ]"
          class="w-56">
          <ng-template let-cutOff #item>
            <div class="flex items-center gap-2">
              <span
                class="size-2 rounded-full"
                [class.bg-green-500]="cutOff.compliance_status === 'compliant'"
                [class.bg-red-500]="cutOff.compliance_status === 'non_compliant'"></span>
              <span>{{ cutOff.date }}</span>
            </div>
          </ng-template>
        </p-select>
      </div>
    </div>
  `,
})
export class CutOffDate {
  public cutOffDateState = inject(CutOffDateState);
  routerState = inject(RouterState);

  analyticsLabel = computed(() => {
    const urlFragmentsWithoutParams = this.routerState
      .urlFragmentsWithoutParams()
      .slice(1);

    return `${urlFragmentsWithoutParams.join('/')}/toolbar/select/cut_off_date`;
  });
}
